<template>
  <div class="a-rms-compset-tooltip">
    <v-tooltip
      content-class="tooltip-shadow compset-tooltip-content"
      color="white"
      :open-delay="400"
      :close-delay="0"
      transition="none"
      right
    >
      <template v-slot:activator="{ on }">
        <v-icon v-on="on" x-small class="cursor-pointer">
          mdi-information-slab-circle-outline
        </v-icon>
      </template>
      <span class="text-center justify-center align-center compset-tooltip">
        <v-data-table
          :headers="headers"
          :items="items"
          :item-class="getDatatableRowClass"
          :hide-default-header="!pickup"
          sort-by="min_price"
          hide-default-footer
          disable-pagination
          dense
        >
          <template v-slot:[`item.competitor_name`]="{ item }">
            <span class="text-caption">{{ item.competitor_name }}</span>
          </template>
          <template v-slot:[`item.competitor_rating`]="{ item }">
            <span class="text-caption">{{ item.competitor_rating }}</span>
          </template>
          <template v-slot:[`item.regime`]="{ item }">
            <span class="text-caption">{{ item.regime }}</span>
          </template>
          <template v-slot:[`item.min_price`]="{ item }">
            <span class="text-caption font-weight-bold">
              {{ item.min_price }}
              <template v-if="item.currency.toLowerCase() === 'eur'">
                <span class="currency-symbol font-weight-bold">€</span>
              </template>
            </span>
          </template>
          <template v-slot:[`item.is_genius_offer`]="{ item }">
            <template v-if="item.is_genius_offer">
              <v-btn color="blue" fab x-small depressed>
                <div class="white--text">g</div>
              </v-btn>
            </template>
          </template>
          <template v-slot:[`item.is_mobile_offer`]="{ item }">
            <template v-if="item.is_mobile_offer">
              <v-btn color="green" fab x-small depressed>
                <div class="white--text">m</div>
              </v-btn>
            </template>
          </template>
          <template v-slot:[`item.min_price_1`]="{ item }">
            <span
              class="text-caption"
              :class="
                item.min_price_1 < item.min_price
                  ? 'green--text'
                  : item.min_price_1 > item.min_price
                  ? 'red--text'
                  : 'black--text'
              "
            >
              {{ item.min_price - item.min_price_1 }}
              <template v-if="item.currency.toLowerCase() === 'eur'">
                <span class="currency-symbol">€</span>
              </template>
            </span>
          </template>
          <template v-slot:[`item.min_price_7`]="{ item }">
            <span
              class="text-caption"
              :class="
                item.min_price_7 < item.min_price
                  ? 'green--text'
                  : item.min_price_7 > item.min_price
                  ? 'red--text'
                  : 'black--text'
              "
            >
              {{ item.min_price - item.min_price_7 }}
              <template v-if="item.currency.toLowerCase() === 'eur'">
                <span class="currency-symbol">€</span>
              </template>
            </span>
          </template>
          <template v-slot:[`item.min_price_14`]="{ item }">
            <span
              class="text-caption"
              :class="
                item.min_price_14 < item.min_price
                  ? 'green--text'
                  : item.min_price_14 > item.min_price
                  ? 'red--text'
                  : 'black--text'
              "
            >
              {{ item.min_price - item.min_price_14 }}
              <template v-if="item.currency.toLowerCase() === 'eur'">
                <span class="currency-symbol">€</span>
              </template>
            </span>
          </template>
          <template v-slot:body.append>
            <tr
              v-if="averageItem"
              class="a-datatable-row font-weight-bold"
              style="background-color: #f5f5f5"
            >
              <td class="text-start pl-4 text-caption font-weight-bold">
                {{ averageItem.competitor_name }}
              </td>
              <td></td>
              <td></td>
              <td class="text-center text-caption font-weight-bold">
                {{ Math.round(averageItem.min_price) }}
                <template
                  v-if="
                    averageItem.currency &&
                      averageItem.currency.toLowerCase() === 'eur'
                  "
                >
                  <span class="currency-symbol font-weight-bold">€</span>
                </template>
              </td>
              <td></td>
              <td></td>
              <template v-if="pickup">
                <td></td>
                <td></td>
                <td></td>
              </template>
            </tr>
          </template>
        </v-data-table>
      </span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "a-rms-compset-tooltip",
  props: {
    date: {
      type: String,
      mandatory: false,
      default: ""
    },
    pickup: {
      type: Boolean,
      mandatory: false,
      default: false
    },
    compsetAvg: {
      type: [Number, String],
      default: null
    }
  },
  computed: {
    headers() {
      const headers = [
        {
          align: "start",
          sortable: true,
          value: "competitor_name",
          text: `COMPSET | ${this.date}`
        },
        {
          align: "center",
          sortable: true,
          value: "competitor_rating"
        },
        {
          align: "center",
          sortable: true,
          value: "regime"
        },
        {
          align: "center",
          sortable: true,
          value: "min_price",
          text: this.$t("min")
        },
        {
          align: "center",
          sortable: true,
          value: "is_genius_offer"
        },
        {
          align: "center",
          sortable: true,
          value: "is_mobile_offer"
        }
      ];
      if (this.pickup) {
        headers.push(
          {
            align: "center",
            sortable: true,
            value: "min_price_1",
            text: "PU1"
          },
          {
            align: "center",
            sortable: true,
            value: "min_price_7",
            text: "PU7"
          },
          {
            align: "center",
            sortable: true,
            value: "min_price_14",
            text: "PU14"
          }
        );
      }
      return headers;
    },
    items() {
      return this.all_kpis_daily_compset[this.date];
    },
    averageItem() {
      if (!this.compsetAvg || !this.items || this.items.length === 0)
        return null;

      return {
        competitor_name: this.$t("compset_avg_min_price"),
        min_price: parseFloat(this.compsetAvg),
        currency: this.items[0].currency
      };
    },
    ...mapState({
      all_kpis_daily_compset: state => state.rms.all_kpis_daily_compset
    })
  },
  methods: {
    getDatatableRowClass(item) {
      let classes = "a-datatable-row";
      if (item.self) {
        classes += " blue lighten-5";
      }
      return classes;
    }
  }
};
</script>

<style lang="scss">
.compset-tooltip-content {
  .v-data-table {
    .v-data-table__wrapper {
      overflow: hidden;
      th {
        padding: 0 !important;
        font-size: 10px !important;
        .v-icon {
          font-size: 12px !important;
        }
      }
      .a-datatable-row {
        td {
          padding: 0 4px !important;
          height: auto !important;
          width: auto !important;
          .currency-symbol {
            margin-left: -3px;
            font-size: 10px !important;
          }
          .v-btn--fab.v-size--x-small {
            height: 15px;
            width: 15px;
          }
        }
      }
    }
  }
}
</style>
